import axios from "axios";
import { API_BASE_URL } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }) {
      const store = this;
      try {
        let response = await axios({
          method: "get",
          url: API_BASE_URL + `/chat?lookup=true`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          }
        });
        const obj = response.data.data;
        let chats = [];
        obj.forEach(function(chat) {
          chats.push({
            id: chat.id,
            customerId: chat.customerId,
            name: chat.name,
            isNotEnded: chat.isNotEnded > 0,
            isUnread: chat.isUnread > 0,
            haveNotResponded: chat.haveNotResponded > 0,
            message: chat.message,
            chatMessageCreatedAt: chat.chatMessageCreatedAt
          });
        });

        if (chats.length > 0) {
          store.dispatch("entities/chatLookups/insertOrUpdate", {
            data: chats
          });
        }
        store.dispatch("entities/settings/setIsOffline", false);
      } catch (error) {
        store.dispatch("entities/settings/setIsOffline", true);
      }
    },

    async clickChatLookup(context, { chatLookup, action, actionDate }) {
      let store = this;
      let accountId = store.state.entities.settings.data[1].accountId;
      let userId = store.state.entities.settings.data[1].userId;

      let updateCustomer = {
        id: chatLookup.customerId,
        accountId: accountId,
        isDirty: true,
        isRead: true // to ensure update of viewedAt
      };
      let chatData = {
        id: chatLookup.id,
        isDirty: true
      };

      if (action == "endChat") {
        chatData.is_ended = true;
        await store.dispatch("entities/chatLookups/update", {
          where: tempMessageLookup => {
            return tempMessageLookup.id === chatLookup.id;
          },
          data: { isNotEnded: false }
        });
      }
      await store.dispatch("entities/chats/updateChat", {
        where: tempMessageLookup => {
          return tempMessageLookup.id === chatLookup.id;
        },
        data: chatData
      });
      if (chatLookup.customerId) {
        await store.dispatch(
          "entities/customers/updateCustomer",
          updateCustomer
        );
      } else {
        let userId = store.state.entities.settings.data[1].userId;
        await store.dispatch("entities/users/update", {
          where: userId,
          data: {
            currentCustomerId: null
          }
        });
      }

      if (!["endChat"].includes(action)) {
        if (chatLookup.customerId) {
          await store.dispatch("entities/customers/fetchCustomerDataJoins", {
            joins:
              null,
            customerId: chatLookup.customerId,
            startFresh: true
          });
          await store.dispatch("entities/users/update", {
            where: userId,
            data: { currentCustomerId: chatLookup.customerId }
          });
          await store.dispatch("entities/customerLookups/update", {
            where: chatLookup.customerId,
            data: { viewedAt: Date.now() }
          });
        } else {
          await store.dispatch("entities/users/update", {
            where: userId,
            data: { currentCustomerId: null }
          });
          await store.dispatch("entities/chats/fetchChatMessages", {
            chatId: chatLookup.id
          });
        }

        await store.dispatch("entities/chatLookups/update", {
          where: tempMessageLookup => {
            return tempMessageLookup.id === chatLookup.id;
          },
          data: { isUnread: false }
        });
      }
      await store.dispatch("entities/accounts/pingAccountLevelDisplay");
    }
  }
};
